import { useTranslation } from 'next-i18next';
import styles from './Benefits.module.scss';
import Image from 'next/dist/client/image';
import { useDeviceSize } from '@climate-science/component-library';
import { changeRouteKeepParams } from 'util/changeRouteKeepParams';
import { useRouter } from 'next/router';
import Button from '@cs/components/olympiad/Button';

const Benefits = () => {
  const { t } = useTranslation("olympiad")
  const router = useRouter()
  const { isTablet, isMobile } = useDeviceSize()

  const CARDS = [
    "summit",
    "mentoring",
    "career",
  ]
  
  return (
    <section className={styles.section}>
      <h2 className={styles.h2}>
        {t("benefits.title")}
      </h2>
      <article className={styles.container}>
        {
          CARDS.map((card, index) => (
            <div key={index} className={styles.card}>
              <figure>
                <Image
                  src={`/img/olympiad/benefits/${card}.png`}
                  alt={t(`benefits.${card}.alt`)}
                  width={isTablet
                    ? 121
                    : isMobile
                      ? 100
                      : 170
                  }
                  height={isTablet
                    ? 100
                    : isMobile
                      ?  80
                      : 140
                  }
                />
              </figure>
              <div className={styles.text}>
                <h3 className={styles.h3}>
                  {t(`benefits.cards.${card}.title`)}
                </h3>
                <p className={styles.p}>
                  {t(`benefits.cards.${card}.text`)}
                </p>
              </div>
            </div>
          ))
        }
      </article>
      <Button
        onClick={() =>
          window.open(
            changeRouteKeepParams(`
          https://olympiad.${process.env.NEXT_PUBLIC_DOMAIN}${
      router.locale == "en" ? "" : "/" + router.locale
    }/signup`),
            "_blank",
          )
        }
        className={styles.button}
      >
        {t("register-now")}
      </Button>
    </section>
  )
}

export default Benefits;